/* eslint-disable */
import { auditOnPlatformDevOrganization } from '../organizations';
import { artemisTestingOrganization } from '../test-organizations/internal-controls-test-organizations';
import { LaunchpadUser } from './types';

export const barbaraSimandiTestUser: LaunchpadUser = {
  email: 'bsimandi@diligent.com',
  password: 'asdQWE123',
  name: 'Barbara Simandi',
  firstName: 'Barbara',
  lastName: 'Simandi',
  initials: 'BS',
  highbondId: '_WxU4MGd2GfnT939Uu83',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB01',
  organization: artemisTestingOrganization,
};

export const benceKissTestUser: LaunchpadUser = {
  email: 'bkiss@diligent.com',
  password: 'asdQWE123',
  name: 'Bence Kiss',
  firstName: 'Bence',
  lastName: 'Kiss',
  initials: 'BK',
  highbondId: 'LLxkeCGxFy6yix9jiNqM',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB02',
  organization: artemisTestingOrganization,
};

export const krisztianKurtiszTestUser: LaunchpadUser = {
  email: 'kkurtisz@diligent.com',
  password: 'asdQWE123',
  name: 'Krisztian Kurtisz',
  firstName: 'Krisztian',
  lastName: 'Kurtisz',
  initials: 'KK',
  highbondId: 'yB5QPRDkTXY_wAtjx3Lf',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB03',
  organization: artemisTestingOrganization,
};

export const laszloCsadiTestUser: LaunchpadUser = {
  email: 'lcsadi@diligent.com',
  password: 'asdQWE123',
  name: 'László Csadi',
  firstName: 'László',
  lastName: 'Csadi',
  initials: 'LC',
  highbondId: 'txcEAsNBsyaSLgGwxSee',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB04',
  organization: artemisTestingOrganization,
};

export const poojaShettyTestUser: LaunchpadUser = {
  email: 'pshetty@diligent.com',
  password: 'asdQWE123',
  name: 'Pooja Shetty',
  firstName: 'Pooja',
  lastName: 'Shetty',
  initials: 'PS',
  highbondId: 'd_znQbaGt5ijXwcypZm5',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB05',
  organization: artemisTestingOrganization,
};

export const peterCsoorTestUser: LaunchpadUser = {
  email: 'pcsoor@diligent.com',
  password: 'asdQWE123',
  name: 'Peter Csoor',
  firstName: 'Peter',
  lastName: 'Csoor',
  initials: 'PC',
  highbondId: 'vT_8n3rDW54833Z-SykT',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB06',
  organization: artemisTestingOrganization,
};

export const zsoltMolnarTestUser: LaunchpadUser = {
  email: 'zsomolnar@diligent.com',
  password: 'asdQWE123',
  name: 'Zsolt Molnar',
  firstName: 'Zsolt',
  lastName: 'Molnar',
  initials: 'ZM',
  highbondId: 'QCxe-RRyoMxzX-PLdCa8',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB07',
  organization: artemisTestingOrganization,
};

export const karolyPakozdiTestUser: LaunchpadUser = {
  email: 'kpakozdi@diligent.com',
  password: 'asdQWE123',
  name: 'Karoly Pákozdi',
  firstName: 'Karoly',
  lastName: 'Pákozdi',
  initials: 'KP',
  highbondId: '35rJCfyooJTKpD4u9RkF',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB08',
  organization: artemisTestingOrganization,
};

export const botondKeveTestUser: LaunchpadUser = {
  email: 'bkeve@diligent.com',
  password: 'asdQWE123',
  name: 'Botond Keve',
  firstName: 'Botond',
  lastName: 'Keve',
  initials: 'BK',
  highbondId: '6yxGb5DUyYLuzjMr1voc',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB09',
  organization: artemisTestingOrganization,
};

export const balazsVargaTestUser: LaunchpadUser = {
  email: 'bavarga@diligent.com',
  password: 'asdQWE123',
  name: 'Balazs Varga',
  firstName: 'Balazs',
  lastName: 'Varga',
  initials: 'BV',
  highbondId: 'Xvs76UNNcXD9n2stsY22',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB10',
  organization: artemisTestingOrganization,
};

export const zoltanLevaiTestUser: LaunchpadUser = {
  email: 'zlevai@diligent.com',
  password: 'asdQWE123',
  name: 'Zoltán Lévai',
  firstName: 'Zoltán',
  lastName: 'Lévai',
  initials: 'ZL',
  highbondId: 'ccpgJuFa4c1BFsJoyxK5',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB11',
  organization: artemisTestingOrganization,
};

export const fruzsinaSipkaTestUser: LaunchpadUser = {
  email: 'fsipka@diligent.com',
  password: 'asdQWE123',
  name: 'Fruzsina Sipka',
  firstName: 'Fruzsina',
  lastName: 'Sipka',
  initials: 'FS',
  highbondId: 'gFu6y_W6xwgsJkLMV9pT',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB12',
  organization: artemisTestingOrganization,
};

export const timeaFerencziTestUser: LaunchpadUser = {
  email: 'tferenczi@diligent.com',
  password: 'asdQWE123',
  name: 'Timea Ferenczi',
  firstName: 'Timea',
  lastName: 'Ferenczi',
  initials: 'TF',
  highbondId: 'kyH-vp6UPVXcuwzGvz-b',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB13',
  organization: artemisTestingOrganization,
};

export const ilkaGaraiTestUser: LaunchpadUser = {
  email: 'igarai@diligent.com',
  password: 'asdQWE123',
  name: 'Ilka Garai',
  firstName: 'Ilka',
  lastName: 'Garai',
  initials: 'IG',
  highbondId: 'G4Pf7F7zfCErye6oMWWB',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'admin',
  id: '8022BE1F-5DFE-4A6D-BEC6-1084CA7D1E3E',
  organization: artemisTestingOrganization,
  secondaryOrganizations: [auditOnPlatformDevOrganization],
};

export const devInternalControlsTestUsers: LaunchpadUser[] = [
  barbaraSimandiTestUser,
  benceKissTestUser,
  krisztianKurtiszTestUser,
  laszloCsadiTestUser,
  poojaShettyTestUser,
  peterCsoorTestUser,
  zsoltMolnarTestUser,
  karolyPakozdiTestUser,
  botondKeveTestUser,
  balazsVargaTestUser,
  zoltanLevaiTestUser,
  fruzsinaSipkaTestUser,
  timeaFerencziTestUser,
  ilkaGaraiTestUser,
];
